<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <form @submit.prevent="recherche()">
              <b-input :placeholder="$t('ecranNumeriqueByBailleur.actions.search')"
                       type="search"
                       v-model="critereRecherche.auto"
                       icon="magnify">
              </b-input>
            </form>
          </div>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('ecranNumeriqueByBailleur.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.EMPLACEMENT.exporter"
            :query="exportExcelQuery"/>
        </div>
      </div>
    </div>
    <div>
      <v-server-table url="" :columns="columns" :options="options" ref="tableListeEcran"
                      @loaded="finLoading" @loading="debutLoading">
        <template slot='afterTable'>
          <table-items-in-view @input="$refs.tableListeEcran.setLimit($event)"/>
        </template>
        <div slot="codeMateriel" slot-scope="props">
          <router-link-blank :message="props.row.codeMateriel"
                             :to="{ name: 'c.gabed.emplacement-detailMateriel',
                           params: { id: props.row.emplacementId,
                           idMateriel: props.row.id }}">
          </router-link-blank>
        </div>
        <div slot="codesBaux" slot-scope="props">
          <router-link-blank v-for="(codeBail, idx) in props.row.codesBaux" :key="idx"
                             :to="{ name: 'c.baux.contrat',
                           params: { id: props.row.idsBaux[idx] }}"
                             :message="codeBail">
          </router-link-blank>
        </div>
        <div slot="dispositifSupport" slot-scope="props">
          {{ getDispositifSupport(props.row.dispositifSupportId) }}
        </div>
        <div slot="dispositifType" slot-scope="props">
          {{ getDispositifTypeLibelle(props.row.dispositifTypeId) }}
        </div>
        <div slot="dateMontage" slot-scope="props">
          {{ props.row.dateMontage | formatDate }}
        </div>
        <div slot="dateDemontage" slot-scope="props">
          {{ props.row.dateDemontage | formatDate}}
        </div>
        <div slot="disposition" slot-scope="props">
          {{ props.row.disposition }}
        </div>
        <div slot="typeMateriel" slot-scope="props">
          {{ getMaterielType(props.row.typeMateriel) }}
        </div>
        <div slot="materielEtat" slot-scope="props">
          {{ $t(getEtatMontage(props.row.materielEtat)) }}
        </div>
        <div slot="adresse" slot-scope="props">
          {{ getAdresse(props.row) }}
        </div>
        <div slot="actif" slot-scope="props">
          <div>{{ props.row.actif ? $t('general.non') : $t('general.oui') }}</div>
        </div>
        <div slot="codeDispositif" slot-scope="props">
          <router-link-blank :message="props.row.codeDispositif"
                             :to="{ name: 'c.gabed.emplacement-detailDispositif',
                           params: { id: props.row.emplacementId,
                           idDispositif: props.row.dispositifId }}">
          </router-link-blank>
        </div>
      </v-server-table>
    </div>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-liste-ecran-by-bailleur ref="filtreEcranBailleur"
                                     @toggleFiltre="setShowFiltre"
                                     @recherche="makeRechercheFilter()">
      </filtre-liste-ecran-by-bailleur>
    </div>
  </div>
</template>

<script>
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import adresseGenerer from '@/services/general/genererAdresse';
import filtreListeEcranByBailleur from '@/components/gabed/materiel/filtreListeEcranByBailleur';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import { ECRANS_BAILLEUR_EXPORT_EXCEL } from '@/configuration/baux/contrat/contratConf';

const Societe = createNamespacedHelpers('societe');
const EcranNumeriqueBailleur = createNamespacedHelpers('ecranNumeriqueBailleur');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ecranNumeriqueBailleur',
  data() {
    return {
      constantes: {
        EMPLACEMENT,
      },
      showFiltre: false,
    };
  },
  components: {
    TableItemsInView,
    routerLinkBlank,
    filtreListeEcranByBailleur,
    exportExcelButton,
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...EcranNumeriqueBailleur.mapActions({
      actionLoadEcranNumeriqueOfBailleur: 'actionLoadEcranNumeriqueOfBailleur',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    recherche() {
      this.$refs.tableListeEcran.refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.showFiltre = !this.showFiltre;
      this.setLockMenu(!this.lockMenu);
      this.recherche();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreEcranBailleur.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreEcranBailleur.initializeFiltre();
      this.$refs.filtreEcranBailleur.viderCritere();
      this.$refs.filtreEcranBailleur.appliquerCritere();
      this.showFiltre = false;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    getAdresse(materiel) {
      const adresse = adresseGenerer();
      adresse.adresse1 = materiel.adresse1;
      adresse.adresse2 = materiel.adresse2;
      adresse.adresse3 = materiel.adresse3;
      adresse.intitule1 = materiel.intitule1;
      adresse.intitule2 = materiel.intitule2;
      adresse.intitule3 = materiel.intitule3;
      adresse.codePostal = materiel.codePostal;
      adresse.ville = materiel.ville;
      adresse.agglomeration = materiel.agglomeration;
      return adressFullStringGetter(adresse, false);
    },
    getDispositifTypeLibelle(id) {
      const dispositifFind = this.parametre(typesParametres.PARAMETRES_KEYS.dispositifType)
        .find((dispositif) => {
          return dispositif.id === id;
        });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getDispositifSupport(id) {
      const dispositifFind = this.parametre(typesParametres.PARAMETRES_KEYS.dispositifSupport)
        .find((dispositif) => {
          return dispositif.id === id;
        });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getMaterielType(typeId) {
      const materielTypeFind = this.parametre(typesParametres.PARAMETRES_KEYS.materielType)
        .find((type) => {
          return type.id === typeId;
        });
      return materielTypeFind ? materielTypeFind.libelle : '';
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...EcranNumeriqueBailleur.mapGetters({
      totalCount: 'totalCount',
      items: 'items',
      critereRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    getFilteredNumber() {
      const critereBan = ['auto', 'societeId', 'actif'];
      let nbCritere = calculNombreCritere(this.critereRecherche, critereBan);
      nbCritere += this.critereRecherche.actif !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = ['codeMateriel', 'codesBaux', 'codeDispositif', 'dispositifType', 'dispositifSupport', 'typeMateriel', 'disposition', 'materielEtat', 'dateMontage', 'dateDemontage', 'adresse', 'actif'];
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeMateriel: this.$i18n.t('ecranNumeriqueByBailleur.tab.codeMateriel'),
          codeDispositif: this.$i18n.t('ecranNumeriqueByBailleur.tab.codeDispositif'),
          dateMontage: this.$i18n.t('ecranNumeriqueByBailleur.tab.dateMontage'),
          dateDemontage: this.$i18n.t('ecranNumeriqueByBailleur.tab.dateDemontage'),
          codesBaux: this.$i18n.t('ecranNumeriqueByBailleur.tab.baux'),
          disposition: this.$i18n.t('ecranNumeriqueByBailleur.tab.disposition'),
          materielEtat: this.$i18n.t('ecranNumeriqueByBailleur.tab.etatMateriel'),
          typeMateriel: this.$i18n.t('ecranNumeriqueByBailleur.tab.typeMateriel'),
          dispositifType: this.$i18n.t('ecranNumeriqueByBailleur.tab.dispositifType'),
          dispositifSupport: this.$i18n.t('ecranNumeriqueByBailleur.tab.dispositifSupport'),
          adresse: this.$i18n.t('ecranNumeriqueByBailleur.tab.adresse'),
          actif: this.$i18n.t('ecranNumeriqueByBailleur.tab.archive'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          if (data.query.datesMontage) {
            data.query.datesMontage.dateDebut = formatIsoDate(data.query.datesMontage.dateDebut);
            data.query.datesMontage.dateFin = formatIsoDate(data.query.datesMontage.dateFin);
          }
          if (data.query.datesDemontage) {
            data.query.datesDemontage.dateDebut = formatIsoDate(
              data.query.datesDemontage.dateDebut,
            );
            data.query.datesDemontage.dateFin = formatIsoDate(data.query.datesDemontage.dateFin);
          }
          data.query.societeId = this.societeActiveId;
          data.query.tiersIds = [this.$route.params.id];
          return this.actionLoadEcranNumeriqueOfBailleur(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {},
        sortable: ['codeMateriel', 'codeDispositif', 'materielEtat', 'typeMateriel', 'disposition', 'dateMontage', 'dateDemontage'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: ECRANS_BAILLEUR_EXPORT_EXCEL,
        typeExport: '',
        filtres: this.lastPayload,
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.dispositifSupport,
        typesParametres.PARAMETRES_KEYS.dispositifType,
        typesParametres.PARAMETRES_KEYS.materielType,
      ]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
